export const RESEND_REASON_LABELS = {
  sale_not_found: "Venda não encontrada",
  not_delivery: "Pedido de retirada",
  wrong_distribution_center: "Pedido de outro centro de distribuição",
  never_sent:
    "Pedido nunca foi enviado para a Abbiamo — use o botão Enviar para a Abbiamo",
  never_returned:
    "Pedido não voltou ao CD — se foi reagendado antes de sair, dê baixa manual na Abbiamo",
  already_reshipped: "Pedido já saiu para entrega de novo",
  unpaid: "Pedido não pago — confirme o pagamento antes de integrar",
  invalid_zip_code: "CEP inválido — corrija o endereço da venda",
  already_resent: "Pedido já foi reenviado — use o botão Reenviar",
  already_integrated: "Pedido já foi integrado à Abbiamo",
  send_in_progress: "Envio já em andamento",
  upsert_failed: "Falha ao registrar o envio",
  not_eligible: "Situação do pedido não permite reenvio",
  delivery_window_expired: "Janela de entrega já venceu",
  max_attempts_reached: "Limite de reenvios atingido",
  resend_in_progress: "Reenvio já em andamento",
  reserve_failed: "Falha ao registrar a tentativa",
  produce_failed: "Falha ao enfileirar o reenvio",
};

export const resendReasonLabel = (reason) =>
  RESEND_REASON_LABELS[reason] || reason;

export const ABBIAMO_STATUS_LABELS = {
  CREATED: "criado",
  PENDING: "pendente",
  DISPATCHED: "despachado",
  COLLECTED: "coletado",
  HANDLING: "em manuseio",
  IN_TRANSIT: "em trânsito",
  START_DELIVERY: "saiu para entrega",
  SUCCESSFUL: "entregue",
  DELIVERED: "entregue",
  FAILED: "falha na entrega",
  DELIVERY_FAILED: "falha na entrega",
  ORDER_FAILED: "falha no pedido",
  RETURNED: "devolvido",
  RETURNING: "em devolução",
  MANUAL_HANDLE: "baixa manual",
  CANCELED: "cancelado",
};

export const abbiamoStatusLabel = (status) =>
  ABBIAMO_STATUS_LABELS[status] || status;

export const DELIVERED_STATUSES = ["SUCCESSFUL", "DELIVERED"];

export const isSendRefusal = (statusCode) =>
  statusCode === 429 || (statusCode >= 500 && statusCode < 600);

export const sendRefusalLabel = (order) =>
  isSendRefusal(order.abbiamoLastSendStatusCode)
    ? "Recusado pela Abbiamo — clique em Enviar novamente"
    : "";

export const resendStatusLabel = (order) => {
  switch (order.abbiamoResendStatus) {
    case "reserved":
      return "Reenviando…";
    case "integrated":
      if (DELIVERED_STATUSES.includes(order.abbiamoResendPreviousStatus)) {
        return `Reenviado (${order.abbiamoLastOrderNumberSent}) — o anterior (${order.abbiamoResendPreviousOrderNumber}) consta ENTREGUE na Abbiamo`;
      }
      return `Reenviado (${order.abbiamoLastOrderNumberSent})`;
    case "blocked":
      if (order.abbiamoResendBlockReason === "already_resent") {
        return `Já reenviado (${order.abbiamoResendPreviousOrderNumber})`;
      }

      if (order.abbiamoResendBlockReason === "sweep_incomplete") {
        return "Não reenviado — instabilidade na Abbiamo, tente em alguns minutos";
      }
      return `Não reenviado — ${order.abbiamoResendPreviousStatus
        ? abbiamoStatusLabel(order.abbiamoResendPreviousStatus)
        : "ver na Abbiamo"}`;
    case "failed":
      return "Falha no reenvio";
    default:
      return sendRefusalLabel(order);
  }
};
